module.exports = __webpack_public_path__ + "static/media/PM113.9998f849.png";